import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SelectedClassroomStateService {
  readonly selectedClassroom$: BehaviorSubject<string> = new BehaviorSubject(
    '',
  );

  get classroomId$(): Observable<string> {
    return this.selectedClassroom$.asObservable();
  }

  get classroomId(): string {
    return this.selectedClassroom$.getValue();
  }

  set classroomId(classroomId: string) {
    sessionStorage.setItem('selectedClassroom', classroomId);
    this.selectedClassroom$.next(classroomId);
  }
}
